/**
 * @vuelto-surface
 * mobile: n/a
 * desktop: ok
 * strategy: inherit
 */
export { TicketDeskFooter as CatalogDeskFooter, type TicketDeskFooterProps as CatalogDeskFooterProps } from '../../shared/ticket/public-api';
